export const throwSlackMutationError = (err: any, fallback: string): never => {
  const errors = err.response?.data?.errors;

  if (Array.isArray(errors)) {
    throw new Error(errors.join(', '));
  }

  if (errors && typeof errors === 'object') {
    throw new Error(Object.values(errors).join(', '));
  }

  const message = err.response?.data?.message ?? err.response?.data?.error;

  if (typeof message === 'string') {
    throw new Error(message);
  }

  throw new Error(fallback);
};
